import type { Locale } from "../types";

type I18nKeys =
  | "close" | "poweredBy"
  | "callback.phoneLabel" | "callback.phonePlaceholder" | "callback.emailLabel" | "callback.emailPlaceholder"
  | "callback.messageLabel" | "callback.messagePlaceholder" | "callback.sendCode" | "callback.sending"
  | "callback.title" | "callback.hint" | "callback.verifyTitle" | "callback.verifyInfo" | "callback.resend" | "callback.confirm"
  | "callback.success" | "callback.required" | "callback.optionalToggle" | "callback.successExpect" | "callback.willCall"
  | "callback.needPhone" | "callback.sendFail" | "callback.sendCodeFail" | "callback.resendIn" | "callback.resendFail"
  | "callback.needFullCode" | "callback.submitting" | "callback.codeError" | "callback.submitFail" | "callback.submitFailRetry"
  | "tc.recName" | "tc.welcome" | "tc.inputPlaceholder" | "tc.send" | "tc.offline"
  | "pv.back"
  | "tc.toVoice" | "tc.toHuman" | "tc.humanRequested"
  | "im.selectChannel" | "im.phoneLabel" | "im.goChat" | "im.hint"
  | "voice.title" | "voice.phoneLabel" | "voice.startCall" | "voice.calling" | "voice.connected" | "voice.ended" | "voice.transferred"
  // voice 屏细化
  | "voice.step1" | "voice.step2" | "voice.step3" | "voice.fieldPhone" | "voice.fieldCode"
  | "voice.phonePlaceholder" | "voice.codePlaceholder" | "voice.getCode" | "voice.resendCode" | "voice.resendCodeCd"
  | "voice.startBtn" | "voice.startDisabledHint" | "voice.privacy"
  | "voice.dialing" | "voice.dialingSub" | "voice.cancel"
  | "voice.tabWave" | "voice.tabChat" | "voice.switchText"
  | "voice.toggleText" | "voice.roleUser" | "voice.roleAgent"
  | "voice.statusListening" | "voice.statusSpeaking" | "voice.statusThinking" | "voice.statusListeningShort"
  | "voice.mute" | "voice.muted" | "voice.unmute" | "voice.hangup" | "voice.chatEmpty"
  | "voice.endedTitle" | "voice.duration" | "voice.endedSummary"
  | "voice.rateLabel" | "voice.rateThanks" | "voice.rateUp" | "voice.rateDown" | "voice.redial" | "voice.leaveContact" | "voice.closeBtn"
  | "voice.retry" | "voice.switchCallback"
  | "voice.errMicDeniedTitle" | "voice.errMicDeniedMsg" | "voice.errNoMicTitle" | "voice.errNoMicMsg"
  | "voice.errFailTitle" | "voice.errFailMsg" | "voice.errUnknown"
  | "voice.needPhone" | "voice.needPhoneCode" | "voice.needCode" | "voice.codeWrong" | "voice.codeWrongRetry" | "voice.sendFail"
  // 启动页
  | "home.recName" | "home.online" | "home.voice" | "home.voiceSub" | "home.text" | "home.textSub"
  | "home.callback" | "home.callbackSub" | "home.imSection"
  | "home.wechatTitle" | "home.wechatScan" | "home.wechatOpened" | "home.wechatFallback"
  | "home.wechatCopy" | "home.wechatCopied" | "home.wechatOpenApp" | "home.wechatSearchHint" | "home.wechatNone"
  // 容器
  | "container.title" | "container.noFeature" | "container.fabOpen" | "container.close" | "container.back";

const zh: Record<I18nKeys, string> = {
  close: "关闭", poweredBy: "Powered by OneCall",
  "callback.phoneLabel": "输入您的手机号", "callback.phonePlaceholder": "(555) 123-4567",
  "callback.emailLabel": "邮箱（选填）", "callback.emailPlaceholder": "your@email.com",
  "callback.messageLabel": "留言（选填）", "callback.messagePlaceholder": "请输入留言内容...",
  "callback.sendCode": "获取验证码", "callback.sending": "发送中...",
  "callback.title": "AI 电话回拨",
  "callback.hint": "我们将很快回拨给您 · 免费试用",
  "callback.verifyTitle": "输入验证码", "callback.verifyInfo": "验证码已发送至 %s ****-%s",
  "callback.resend": "重新发送", "callback.confirm": "请求回拨",
  "callback.success": "回拨请求已提交，请留意手机来电",
  "callback.required": "必填", "callback.optionalToggle": "添加邮箱 / 留言（选填）",
  "callback.successExpect": "通常 1 分钟内来电；若未接通，我们会以短信通知您。", "callback.willCall": "我们将很快回拨到",
  "callback.needPhone": "请输入手机号", "callback.sendFail": "发送失败", "callback.sendCodeFail": "发送验证码失败，请稍后重试",
  "callback.resendIn": "%ss 后重发", "callback.resendFail": "重发验证码失败", "callback.needFullCode": "请输入完整验证码",
  "callback.submitting": "提交中...", "callback.codeError": "验证码错误", "callback.submitFail": "提交失败", "callback.submitFailRetry": "提交失败，请重试",
  "tc.recName": "AI 助手", "tc.welcome": "你好，有什么可以帮你的？", "tc.inputPlaceholder": "输入你的问题…", "tc.send": "发送", "tc.offline": "AI 助手暂未连接，客服稍后会回复您",
  "pv.back": "返回上一步",
  "tc.toVoice": "转语音通话", "tc.toHuman": "转人工", "tc.humanRequested": "已为您转接人工客服，请稍候…",
  "im.selectChannel": "请选择沟通方式", "im.phoneLabel": "您的手机号（用于线索记录）",
  "im.goChat": "开始对话", "im.hint": "点击后将跳转到对应平台",
  "voice.title": "AI 语音接待", "voice.phoneLabel": "输入您的手机号",
  "voice.startCall": "AI 语音回拨", "voice.calling": "正在呼叫...",
  "voice.connected": "通话中", "voice.ended": "通话已结束", "voice.transferred": "已转接人工客服",
  "voice.step1": "输入手机号", "voice.step2": "获取并填写验证码", "voice.step3": "开始通话",
  "voice.fieldPhone": "手机号", "voice.fieldCode": "验证码",
  "voice.phonePlaceholder": "请输入手机号码", "voice.codePlaceholder": "输入 6 位验证码",
  "voice.getCode": "获取验证码", "voice.resendCode": "重新获取验证码", "voice.resendCodeCd": "重新获取(%ss)",
  "voice.startBtn": "开始语音对话", "voice.startDisabledHint": "请先完成手机验证后开始通话",
  "voice.privacy": "手机号仅用于本次通话验证与必要回拨，不会泄露给第三方",
  "voice.dialing": "正在呼叫 AI 接待员", "voice.dialingSub": "通常 3-5 秒内接通", "voice.cancel": "取消",
  "voice.tabWave": "声纹波动", "voice.tabChat": "文字对话", "voice.switchText": "切换到文本对话",
  "voice.toggleText": "文字", "voice.roleUser": "客户", "voice.roleAgent": "AI 接待员",
  "voice.statusListening": "通话中 · 正在聆听", "voice.statusSpeaking": "AI 正在回答",
  "voice.statusThinking": "AI 正在思考…", "voice.statusListeningShort": "正在聆听…",
  "voice.mute": "静音", "voice.muted": "已静音", "voice.unmute": "取消静音", "voice.hangup": "挂断",
  "voice.chatEmpty": "对话内容将在此显示",
  "voice.endedTitle": "通话已结束", "voice.duration": "通话时长 %s",
  "voice.endedSummary": "我们已记录您本次咨询，如需进一步帮助可重新对话或留下联系方式。",
  "voice.rateLabel": "本次服务满意吗？", "voice.rateThanks": "感谢您的反馈！", "voice.rateUp": "满意", "voice.rateDown": "不满意",
  "voice.redial": "重新对话", "voice.leaveContact": "需要回电 / 加微信？留个联系方式", "voice.closeBtn": "关闭",
  "voice.retry": "重试", "voice.switchCallback": "改用回拨电话",
  "voice.errMicDeniedTitle": "麦克风未授权",
  "voice.errMicDeniedMsg": "语音通话需要麦克风权限。请点击浏览器地址栏的权限图标允许麦克风后重试，或改用回拨电话。",
  "voice.errNoMicTitle": "未检测到麦克风",
  "voice.errNoMicMsg": "未找到可用的麦克风设备。请检查设备后重试，或改用回拨电话。",
  "voice.errFailTitle": "连接失败", "voice.errFailMsg": "呼叫未能接通，请重试。", "voice.errUnknown": "请稍后重试。",
  "voice.needPhone": "请输入手机号码", "voice.needPhoneCode": "请输入手机号码和验证码",
  "voice.needCode": "请先获取验证码", "voice.codeWrong": "验证码错误", "voice.codeWrongRetry": "验证码错误，请重试", "voice.sendFail": "验证码发送失败",
  "home.recName": "AI 助手", "home.online": "在线 · 通常几秒内回复",
  "home.voice": "语音对话", "home.voiceSub": "和 AI 实时通话，可随时转人工",
  "home.text": "文本对话", "home.textSub": "打字咨询，AI 即时回复",
  "home.callback": "回拨电话", "home.callbackSub": "留下号码，我们尽快回拨给您",
  "home.imSection": "其他沟通方式",
  "home.wechatTitle": "微信", "home.wechatScan": "微信扫一扫，添加客服",
  "home.wechatOpened": "已为您打开微信客服", "home.wechatFallback": "未跳转？点此打开",
  "home.wechatCopy": "复制微信号", "home.wechatCopied": "已复制", "home.wechatOpenApp": "在微信中打开",
  "home.wechatSearchHint": "打开微信，搜索 / 扫码添加该客服", "home.wechatNone": "暂未配置微信客服",
  "container.title": "客服助手", "container.noFeature": "无可用功能",
  "container.fabOpen": "打开客服助手", "container.close": "关闭", "container.back": "返回",
};

const en: Record<I18nKeys, string> = {
  close: "Close", poweredBy: "Powered by OneCall",
  "callback.phoneLabel": "Enter your phone number", "callback.phonePlaceholder": "(555) 123-4567",
  "callback.emailLabel": "Email (optional)", "callback.emailPlaceholder": "your@email.com",
  "callback.messageLabel": "Message (optional)", "callback.messagePlaceholder": "Leave a message...",
  "callback.sendCode": "Send Verification Code", "callback.sending": "Sending...",
  "callback.title": "AI Callback",
  "callback.hint": "We'll call you back soon · Free trial",
  "callback.verifyTitle": "Enter verification code", "callback.verifyInfo": "Code sent to %s ****-%s",
  "callback.resend": "Resend", "callback.confirm": "Request Callback",
  "callback.success": "Callback requested. Please wait for the call.",
  "callback.required": "Required", "callback.optionalToggle": "Add email / message (optional)",
  "callback.successExpect": "Usually called within 1 minute; if we miss you, we'll text you.", "callback.willCall": "We'll call you shortly at",
  "callback.needPhone": "Please enter your phone number", "callback.sendFail": "Failed to send", "callback.sendCodeFail": "Failed to send code, please try again later",
  "callback.resendIn": "Resend in %ss", "callback.resendFail": "Failed to resend code", "callback.needFullCode": "Please enter the full code",
  "callback.submitting": "Submitting...", "callback.codeError": "Wrong code", "callback.submitFail": "Submission failed", "callback.submitFailRetry": "Submission failed, please retry",
  "tc.recName": "AI Assistant", "tc.welcome": "Hi, how can I help you?", "tc.inputPlaceholder": "Type your question…", "tc.send": "Send", "tc.offline": "AI assistant is offline; an agent will reply soon",
  "pv.back": "Back",
  "tc.toVoice": "Switch to voice call", "tc.toHuman": "Talk to a human", "tc.humanRequested": "Connecting you to a human agent…",
  "im.selectChannel": "Select a channel", "im.phoneLabel": "Your phone (for lead tracking)",
  "im.goChat": "Start Chat", "im.hint": "You will be redirected to the platform",
  "voice.title": "AI Voice Assistant", "voice.phoneLabel": "Enter your phone number",
  "voice.startCall": "AI Voice Call", "voice.calling": "Calling...",
  "voice.connected": "Connected", "voice.ended": "Call ended", "voice.transferred": "Transferred to human agent",
  "voice.step1": "Enter phone", "voice.step2": "Get & enter code", "voice.step3": "Start call",
  "voice.fieldPhone": "Phone", "voice.fieldCode": "Code",
  "voice.phonePlaceholder": "Enter phone number", "voice.codePlaceholder": "Enter 6-digit code",
  "voice.getCode": "Get code", "voice.resendCode": "Resend code", "voice.resendCodeCd": "Resend (%ss)",
  "voice.startBtn": "Start voice chat", "voice.startDisabledHint": "Complete phone verification to start",
  "voice.privacy": "Your number is used only for this call's verification and necessary callback — never shared.",
  "voice.dialing": "Calling AI receptionist", "voice.dialingSub": "Usually connects within 3-5s", "voice.cancel": "Cancel",
  "voice.tabWave": "Voice wave", "voice.tabChat": "Transcript", "voice.switchText": "Switch to text chat",
  "voice.toggleText": "Text", "voice.roleUser": "You", "voice.roleAgent": "AI agent",
  "voice.statusListening": "In call · Listening", "voice.statusSpeaking": "AI is responding",
  "voice.statusThinking": "AI is thinking…", "voice.statusListeningShort": "Listening…",
  "voice.mute": "Mute", "voice.muted": "Muted", "voice.unmute": "Unmute", "voice.hangup": "Hang up",
  "voice.chatEmpty": "Conversation will appear here",
  "voice.endedTitle": "Call ended", "voice.duration": "Duration %s",
  "voice.endedSummary": "We've logged your inquiry. Start again or leave your contact for more help.",
  "voice.rateLabel": "How was your experience?", "voice.rateThanks": "Thanks for your feedback!", "voice.rateUp": "Satisfied", "voice.rateDown": "Not satisfied",
  "voice.redial": "Talk again", "voice.leaveContact": "Need a callback / WeChat? Leave your contact", "voice.closeBtn": "Close",
  "voice.retry": "Retry", "voice.switchCallback": "Use callback instead",
  "voice.errMicDeniedTitle": "Microphone not allowed",
  "voice.errMicDeniedMsg": "Voice calls need microphone access. Allow the mic via your browser's address-bar permission icon and retry, or use a callback.",
  "voice.errNoMicTitle": "No microphone found",
  "voice.errNoMicMsg": "No usable microphone device. Check your device and retry, or use a callback.",
  "voice.errFailTitle": "Connection failed", "voice.errFailMsg": "The call couldn't connect. Please retry.", "voice.errUnknown": "Please try again later.",
  "voice.needPhone": "Please enter your phone number", "voice.needPhoneCode": "Please enter phone number and code",
  "voice.needCode": "Please get a verification code first", "voice.codeWrong": "Wrong code", "voice.codeWrongRetry": "Wrong code, please retry", "voice.sendFail": "Failed to send code",
  "home.recName": "AI Assistant", "home.online": "Online · usually replies in seconds",
  "home.voice": "Voice Call", "home.voiceSub": "Talk to AI live, transfer to a human anytime",
  "home.text": "Text Chat", "home.textSub": "Type to chat, instant AI replies",
  "home.callback": "Request a Callback", "home.callbackSub": "Leave your number, we'll call you back",
  "home.imSection": "Other channels",
  "home.wechatTitle": "WeChat", "home.wechatScan": "Scan with WeChat to add support",
  "home.wechatOpened": "Opening WeChat support…", "home.wechatFallback": "Not redirected? Tap to open",
  "home.wechatCopy": "Copy WeChat ID", "home.wechatCopied": "Copied", "home.wechatOpenApp": "Open in WeChat",
  "home.wechatSearchHint": "Open WeChat, then search / scan to add support", "home.wechatNone": "WeChat support not configured yet",
  "container.title": "Support", "container.noFeature": "No feature available",
  "container.fabOpen": "Open support assistant", "container.close": "Close", "container.back": "Back",
};

const bundles: Record<Locale, Record<I18nKeys, string>> = { "zh-CN": zh, "en-US": en };

export function t(key: I18nKeys, locale: Locale, ...args: string[]): string {
  const bundle = bundles[locale] || bundles["zh-CN"];
  let text = bundle[key] || key;
  for (let i = 0; i < args.length; i++) text = text.replace("%s", args[i]);
  return text;
}
